// import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider, App, } from 'antd';
import AppRoot from './App';
import ErrorBoundary from './components/error-boundary';

import "./assets/styles/default.css";
import './assets/styles/quill.snow.css';
import './assets/styles/cryptofont.css';
import './assets/styles/migrate.bootstrap.antd.css';
import './assets/styles/custom.css';
import './assets/styles/style-thema.css';
import "@fontsource/quicksand";

const container = document.getElementById('root');
const root = createRoot(container);

/*
sea-green: #33b8bb
hover: #1b6769ff
*/

const defaultData = {
  borderRadius: 2,
  colorPrimary: "#33b8bb",
  colorPrimaryHover: "#1b6769ff",
  hashed: false,
};

root.render(
  <ConfigProvider
    csp={{ nonce: `${process.env.REACT_APP_GENERATED_NONCE_VALUE}` }}
    theme={{
      token: {
        fontFamily: "Quicksand",
        fontSize: 16,
        colorPrimary: defaultData.colorPrimary,
        colorPrimaryHover: defaultData.colorPrimaryHover,
        borderRadius: defaultData.borderRadius,
      },
      components: {
        Modal: {
          contentBg: "#f3f3f3"
        },
        Notification: {
          width: 384,
        },
      },
    }}>
    <App>
      <ErrorBoundary>
        <AppRoot />
      </ErrorBoundary>
    </App>
  </ConfigProvider>
);
